import React from 'react';
import { Grid, Segment, Table } from 'semantic-ui-react';

import { Motivo, ResumenesDeCurso } from '../tipos';
import FilaCambioDeCurso from './FilaCambioDeCurso';
import FormularioMotivoDeCambio from './FormularioMotivoDeCambio';
import RegistroDeCambios, { Props as CambiosProps } from './RegistroDeCambios';

type Cambio = Readonly<{
    origen: number;
    destino: number;
}>;

export type Props = Readonly<{
    cursosInscritos: Readonly<ResumenesDeCurso>;
    cursos: Readonly<ResumenesDeCurso>;
    registrosDeCambios: CambiosProps['registros'];
    alPresionarCambiar: (cambios: readonly Cambio[], motivo: Motivo) => Promise<void>;
}>;

type State = Readonly<{
    cursosPorBloque: ReadonlyMap<string, ResumenesDeCurso>;
    cursosDeDestino: ReadonlyArray<number | undefined>;
}>;

class PanelDeCambios extends React.Component<Props, State> {
    public readonly state = {
        cursosDeDestino: [],
        cursosPorBloque: cursosSeparadosPorBloque(this.props.cursos),
    };

    public componentDidUpdate(prevProps: Props) {
        if (prevProps.cursos !== this.props.cursos && this.props.cursos.length > 0) {
            this.setState({ cursosPorBloque: cursosSeparadosPorBloque(this.props.cursos) });
        }
    }

    public render() {
        const { cursosPorBloque, cursosDeDestino } = this.state;

        return (
            <Segment>
                <Table compact striped>
                    <Table.Body>
                        {this.props.cursosInscritos.map((curso, indice) => (
                            <FilaCambioDeCurso
                                key={curso.id}
                                cursoInscrito={curso}
                                cursosDelBloque={cursosPorBloque.get(curso.bloque) || []}
                                cursoDeDestino={this.props.cursos.find(
                                    cur => cur.id === cursosDeDestino[indice],
                                )}
                                alCambiarDestino={idCurso =>
                                    this.setState(ps => {
                                        const destinos = [...ps.cursosDeDestino];
                                        destinos[indice] = idCurso;
                                        return { cursosDeDestino: destinos };
                                    })
                                }
                            />
                        ))}
                    </Table.Body>
                </Table>

                <Grid>
                    <Grid.Column width='8'>
                        <FormularioMotivoDeCambio alPresionarCambiar={this.reportarCambios} />
                    </Grid.Column>
                    <Grid.Column width='8'>
                        <RegistroDeCambios registros={this.props.registrosDeCambios} />
                    </Grid.Column>
                </Grid>
            </Segment>
        );
    }

    private readonly reportarCambios = async (motivo: Motivo) => {
        const { cursosDeDestino } = this.state;
        const { cursosInscritos, alPresionarCambiar } = this.props;

        const cambios = cursosDeDestino.reduce(
            (acc, destino, i) =>
                destino ? acc.concat({ origen: cursosInscritos[i].id, destino }) : acc,
            [] as Cambio[],
        );
        return alPresionarCambiar(cambios, motivo)
            .then(() => this.setState({ cursosDeDestino: [] }))
            .catch();
    };
}

function cursosSeparadosPorBloque(cursos: Readonly<ResumenesDeCurso>) {
    const cursosOrdenados = cursos
        .filter(c => c.capacidad - c.inscritos > 0)
        .sort(
            (a, b) =>
                a.dia - b.dia ||
                compararBloqueHorario(a.bloqueHorario, b.bloqueHorario) ||
                a.id - b.id,
        );
    const mapa = new Map<string, ResumenesDeCurso>();
    for (const curso of cursosOrdenados) {
        const cursosDelBloque = mapa.get(curso.bloque) || [];
        cursosDelBloque.push(curso);
        mapa.set(curso.bloque, cursosDelBloque);
    }
    return mapa;
}

type BloqueHorario = ResumenesDeCurso[number]['bloqueHorario'];
function compararBloqueHorario(a: BloqueHorario, b: BloqueHorario): number {
    return (
        compararComparables(a.horaInicio, b.horaInicio) ||
        compararComparables(a.horaTermino, b.horaTermino)
    );
}

function compararComparables(a: {}, b: {}): number {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}

export default PanelDeCambios;



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/CambiosDeCurso/componentes/PanelDeCambios.tsx